import React, { useEffect } from "react";
import User from "../components/User";
import AllCards from "../components/AllCards";
import {
  firstFetchProfileCards,
  cancelProfileCardsListener,
} from "../redux/actions/cardsActions";
import { useDispatch, useSelector } from "react-redux";
const UserActivities = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.authReducer.userId);

  useEffect(() => {
    dispatch(firstFetchProfileCards(currentUser));
    return () => {
      dispatch(cancelProfileCardsListener());
    };
  }, []);

  return (
    <div className="text-gray-700 w-full my-8 ">
      <User />
      <div className="">
        <AllCards fromPage={"UserActivities"} />
      </div>
    </div>
  );
};
export default UserActivities;
